import { Component, ViewEncapsulation } from '@angular/core';
import { MenuItem } from 'primeng/api';
import { AppConfig } from 'src/app/configs/app.config';
import {
  APP_COPYRIGHT_FULL,
  APP_COPYRIGHT_SHORT,
  APP_HOME_PATH,
  LS_SIDEBAR,
} from 'src/app/constants/app.constant';
import { CommonService } from 'src/app/services/common/common.service';
import { Router, NavigationEnd } from '@angular/router';
import { AuthorizationService } from 'src/app/api/common/services/authorization.service';
import { BreadcrumbService } from 'src/app/services/breadcrumb/breadcrumb.service';
import { ObjectUtilService } from 'src/app/services/common/object-util.service';
import { environment } from 'src/environments/environment';
import { AuthService } from 'src/app/services/authorization/auth.service';
import { StringUtilService } from 'src/app/services/common/string-util.service';

@Component({
  selector: 'app-layout',
  templateUrl: './layout.component.html',
  styleUrls: ['./layout.component.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class LayoutComponent {
  constructor(
    private common: CommonService,
    private router: Router,
    private authorization: AuthorizationService,
    public breadcrumbService: BreadcrumbService,
    private objUtil: ObjectUtilService,
    private authService: AuthService,
    private stringUtil: StringUtilService
  ) {
    // router.events.subscribe((val) => {
    //   // see also
    //   if (val instanceof NavigationEnd) {
    //     const _this = this;
    //     var intervalId: any = null;
    //     var intervalFunction = function () {
    //       if (_this.menuItems.length) {
    //         clearInterval(intervalId);
    //         let test = _this.common.findPathData(
    //           _this.menuItems,
    //           val.urlAfterRedirects
    //         );
    //         // console.log(test);
    //         if (!!test && test.length) {
    //           _this.breadcrumbItems = [];
    //           if (val.urlAfterRedirects !== APP_HOME_PATH) {
    //             let currentMenu = _this.menuItems[test[0]] as any;
    //             _this.breadcrumbItems.push(currentMenu);
    //             test.splice(0, 1);
    //             test.forEach((x: string) => {
    //               if (x !== 'routerLink') {
    //                 currentMenu = currentMenu[x];
    //                 if (x !== 'items') {
    //                   _this.breadcrumbItems.push(currentMenu);
    //                 }
    //               }
    //             });
    //           }
    //           // console.log(_this.breadcrumbItems);
    //         }
    //       }
    //     };
    //     intervalId = setInterval(intervalFunction, 50);
    //   }
    // });
  }

  //----------------------------  Get Set  --------------------------------//
  isMobile = this.common.isMobile();

  //----------------------------  Constant  --------------------------------//
  readonly AppConfig = AppConfig;
  readonly APP_COPYRIGHT = !this.isMobile
    ? APP_COPYRIGHT_FULL
    : APP_COPYRIGHT_SHORT;

  //----------------------------  Valiable  --------------------------------//
  sidebarVisible: boolean = true;
  menuItems: MenuItem[] = [];
  breadcrumbItems: MenuItem[] = [];
  home!: MenuItem;

  ngOnInit() {
    const sidebarStage = this.isMobile
      ? 'hide'
      : this.common.getLocalStorage(LS_SIDEBAR);
    if (!!sidebarStage) {
      this.sidebarVisible = sidebarStage === 'show';
      this.common.setLocalStorage(
        LS_SIDEBAR,
        this.sidebarVisible ? 'show' : 'hide'
      );
    }

    this.home = { icon: 'pi pi-home', routerLink: '/' };

    this.authorization.getUserMenu().subscribe((res) => {
      if (res.isSuccess) {
        this.menuItems = res.data;
        if (environment.requireAuthen && this.menuItems.length) {
          const stack = [this.menuItems];
          while (stack?.length > 0) {
            const currentObj = stack.pop() as any;
            Object.keys(currentObj as any).forEach((key) => {
              // console.log(`key: ${key}`, currentObj[key]);
              if (
                !!currentObj[key].visible &&
                currentObj[key].routerLink !== '/home'
              ) {
                const pathData = this.common.findPathDataFormatted(
                  this.authService.userMenu,
                  currentObj[key].id,
                  ''
                );
                // console.log(currentObj[key].label, currentObj[key].id, pathData);
                if (this.stringUtil.isEmpty(pathData)) {
                  currentObj[key].visible = false;
                }
              }
              if (
                typeof currentObj[key] === 'object' &&
                currentObj[key] !== null
              ) {
                stack.push(currentObj[key]);
              }
            });
          }
          this.menuItems.forEach((item) => {
            let findItem = this.authService.userMenu.find(
              (x) => x.id + '' == item.id + ''
            );
            // console.log(findItem);

            if (!!findItem) {
              item.visible = findItem.isVisible;
              item.items?.forEach((sub) => {
                let findSub = findItem?.items.find(
                  (x) => x.id + '' == sub.id + ''
                );
                // console.log(findSub);
                if (!!findSub) {
                  sub.visible = findSub.isVisible;
                } else {
                  sub.visible = false;
                }
              });
            } else {
              item.visible = false;
            }
          });
          this.menuItems.forEach((item) => {
            if (item.items?.every((sub) => !sub.visible)) {
              item.visible = false;
            }
          });
        }
        this.breadcrumbService.menuItems = this.objUtil.copyObject(
          this.menuItems
        );
        // console.log(this.breadcrumbService.menuItems);
      }
    });
  }

  //#region handle event function
  onToggleSidebar(event: boolean) {
    this.common.setLocalStorage(LS_SIDEBAR, event ? 'show' : 'hide');
  }
  //#ednregion
  onClickPrivacyNotice(){
    window.open("https://www.scgchemicals.com/en/privacy-notice", '_blank');
  }

  onClickCookieNotice(){
    window.open("https://www.scgchemicals.com/en/cookies-policy", '_blank');
  }
}
